import {useAccountContext} from '../layout/AccountLayout'
import {getNavigationPaths} from '../../services/navigation'
import React from 'react'
import Breadcrumbs from '../navigation/Breadcrumbs'
import PaymentTabs from './PaymentTabs'
import Alert from '../common/Alert'
import {Link, useSearchParams} from 'react-router-dom'

const MakePaymentResultPage = () => {
  const {accountId} = useAccountContext()
  const paths = getNavigationPaths(accountId)

  // get payment amount from query string
  const [searchParams] = useSearchParams()
  const hasError = searchParams.get('error') === 'true'

  return (
    <section>
      <Breadcrumbs
        items={[
          {label: 'Account', path: paths.Account, active: false},
          {label: 'Make a Payment', path: paths.MakePayment, active: false},
          {label: 'Payment Result', active: true}
        ]}
      />

      <PaymentTabs accountId={accountId} />

      <div className="card-default w-full">
        <div className="card-body-default">
          <h1 className="card-header">Make a Payment</h1>

          {hasError ? (
            <Alert type="error">
              <div>
                <h2 className="text-lg mb-2">
                  An error occurred while submitting your payment.
                </h2>
                <p>
                  If the problem persists, please contact support:
                  <br />
                  <a
                    className="link"
                    target="_blank"
                    href="mailto:hello@placemakr.com"
                  >
                    hello@placemakr.com
                  </a>
                </p>
              </div>
            </Alert>
          ) : (
            <Alert type="success">
              <div>
                <h2 className="text-lg mb-2">Thank you for your payment!</h2>
                <p>
                  You're payment is currently being processed. Processing
                  typically takes a few minutes. You should receive a payment
                  confirmation email shortly. If you have any issues, please
                  contact support:
                  <br />
                  <a
                    className="link"
                    target="_blank"
                    href="mailto:hello@placemakr.com"
                  >
                    hello@placemakr.com
                  </a>
                </p>
              </div>
            </Alert>
          )}

          <Link to={paths.MakePayment} className="link-primary mt-4">
            &lt; Back to Payments
          </Link>
        </div>
      </div>
    </section>
  )
}

export default MakePaymentResultPage
